import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback } from "reactstrap";
import Select from "react-select";

import { getFormOfRequests } from "common/services/govt-requests.service";
import { normalize } from "common/lib/normalize";

const SelectRequestForm = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.formOfGovernmentRequest &&
        validation.errors.formOfGovernmentRequest
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.formOfGovernmentRequest &&
          validation.errors.formOfGovernmentRequest
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getFormOfRequests({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const options = useMemo(() => {
    const mainOptions = data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });

    // mainOptions.unshift({ value: null, label: "None" });
    return mainOptions;
  }, [data]);

  return (
    <>
      <Label htmlFor="formOfGovernmentRequest-field" className="form-label">
        Form of Government Request
      </Label>
      <Select
        isClearable
        name="formOfGovernmentRequest"
        id="formOfGovernmentRequest"
        value={
          validation.values.formOfGovernmentRequest?.value
            ? validation.values.formOfGovernmentRequest
            : null
        }
        placeholder="Select form of government request"
        onChange={(value: any) => {
          validation.setFieldValue("formOfGovernmentRequest", value);
          validation.setFieldError("formOfGovernmentRequest", "");
        }}
        options={options}
        onBlur={() =>
          validation.setFieldTouched("formOfGovernmentRequest", true)
        }
        className={
          validation.touched.formOfGovernmentRequest &&
          validation.errors.formOfGovernmentRequest
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>
        {validation.errors.formOfGovernmentRequest?.value}
      </FormFeedback>
    </>
  );
};

export default SelectRequestForm;
